import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { SendToLocalNotificationMessage } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { DeliveryCartableCollectorViewModel } from "../deliveryCartableCollector/deliveryCartableCollector-viewModel";
import { DeliveryCartablesListViewModel } from "../deliveryCartablesList/deliveryCartablesList-viewModel";
import { DeliveryFormViewModel } from "../deliveryForm/deliveryForm-viewModel";
import  { DeliveryCartableDetailView } from "./deliveryCartableDetail-view"
import { stringIsNullOrEmpty } from "src/common/utilities";

export class DeliveryCartableDetailViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: DeliveryCartablesListViewModel, invoiceId:string, warehousePartId:string) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.lineItems = ObservableArray.create();
        this.firstWarehouseItems = ObservableArray.create();
        this.secondWarehouseItems = ObservableArray.create();
        this.allWarehousesView = false;
        this.canViewAllWarehouses = false;

        this.loadById(invoiceId, warehousePartId);
    }
    GetDefaultView(): View <ViewModel> {
        return new DeliveryCartableDetailView();
    }
    public getTypeId(): string {
        return "VM-50DC71D6-158A-4616-94CD-60CA5A53DBB1"
    }
    private _typedParent : DeliveryCartablesListViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set warehousePartId(v: string) { this._warehousePartId = v; } public get warehousePartId(): string { return this._warehousePartId;} private _warehousePartId: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set collectorId(v: string) { this._collectorId = v; } public get collectorId(): string { return this._collectorId;} private _collectorId: string;
    public set collectorName(v: string) { this._collectorName = v; } public get collectorName(): string { return this._collectorName; } private _collectorName: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName; } private _receiverName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set deliveryTime(v: moment.Moment) { this._deliveryTime = v; } public get deliveryTime(): moment.Moment { return this._deliveryTime;} private _deliveryTime: moment.Moment;
    public set collectTime(v: moment.Moment) { this._collectTime = v; } public get collectTime(): moment.Moment { return this._collectTime;} private _collectTime: moment.Moment;
    public set sentTime(v: moment.Moment) { this._sentTime = v; } public get sentTime(): moment.Moment { return this._sentTime;} private _sentTime: moment.Moment;
    public set shippingWarehouseState(v: number) { this._shippingWarehouseState = v; } public get shippingWarehouseState(): number { return this._shippingWarehouseState;} private _shippingWarehouseState: number;
    public set warehouseState(v: number) { this._warehouseState = v; } public get warehouseState(): number { return this._warehouseState; } private _warehouseState: number;
    public set saleFromWarehouseId(v: string) { this._saleFromWarehouseId = v; } public get saleFromWarehouseId(): string { return this._saleFromWarehouseId; } private _saleFromWarehouseId: string;
    public set saleFromWarehouseName(v: string) { this._saleFromWarehouseName = v; } public get saleFromWarehouseName(): string { return this._saleFromWarehouseName; } private _saleFromWarehouseName: string;
    public set deliveryWarehouseId(v: string) { this._deliveryWarehouseId = v; } public get deliveryWarehouseId(): string { return this._deliveryWarehouseId; } private _deliveryWarehouseId: string;
    public set deliveryWarehouseName(v: string) { this._deliveryWarehouseName = v; } public get deliveryWarehouseName(): string { return this._deliveryWarehouseName; } private _deliveryWarehouseName: string;
    public set isDeliveryFormPrinted(v: boolean) { this._isDeliveryFormPrinted = v; } public get isDeliveryFormPrinted(): boolean { return this._isDeliveryFormPrinted; } private _isDeliveryFormPrinted: boolean;
    public set paymentState(v: number) { this._paymentState = v; } public get paymentState(): number { return this._paymentState; } private _paymentState: number;
    public set itemsCount(v: number) { this._itemsCount = v; } public get itemsCount(): number { return this._itemsCount;} private _itemsCount: number;
    public set canDelivery(v: boolean) { this._canDelivery = v; } public get canDelivery(): boolean { return this._canDelivery;} private _canDelivery: boolean;
    public set canCollect(v: boolean) { this._canCollect = v; } public get canCollect(): boolean { return this._canCollect;} private _canCollect: boolean;
    public set canPrint(v: boolean) { this._canPrint = v; } public get canPrint(): boolean { return this._canPrint;} private _canPrint: boolean;
    public set lineItems(v: ObservableArray<DeliveryCartableLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<DeliveryCartableLineItem> { return this._lineItems; } private _lineItems: ObservableArray<DeliveryCartableLineItem>;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    public set isMainDistrict(v: boolean) { this._isMainDistrict = v; } public get isMainDistrict(): boolean { return this._isMainDistrict;} private _isMainDistrict: boolean;
    public set isFirstWarehouseExists(v: boolean) { this._isFirstWarehouseExists = v; } public get isFirstWarehouseExists(): boolean { return this._isFirstWarehouseExists;} private _isFirstWarehouseExists: boolean;
    public set firstWarehouseName(v: string) { this._firstWarehouseName = v; } public get firstWarehouseName(): string { return this._firstWarehouseName;} private _firstWarehouseName: string;
    public set firstWarehouseItems(v: ObservableArray<DeliveryCartableLineItem>) { this._firstWarehouseItems = v; } public get firstWarehouseItems(): ObservableArray<DeliveryCartableLineItem> { return this._firstWarehouseItems;} private _firstWarehouseItems: ObservableArray<DeliveryCartableLineItem>;
    
    public set isSecondWarehouseExists(v: boolean) { this._isSecondWarehouseExists = v; } public get isSecondWarehouseExists(): boolean { return this._isSecondWarehouseExists;} private _isSecondWarehouseExists: boolean;
    public set secondWarehouseName(v: string) { this._secondWarehouseName = v; } public get secondWarehouseName(): string { return this._secondWarehouseName;} private _secondWarehouseName: string;
    public set secondWarehouseItems(v: ObservableArray<DeliveryCartableLineItem>) { this._secondWarehouseItems = v; } public get secondWarehouseItems(): ObservableArray<DeliveryCartableLineItem> { return this._secondWarehouseItems;} private _secondWarehouseItems: ObservableArray<DeliveryCartableLineItem>;
    
    public set allWarehousesView(v: boolean) { this._allWarehousesView = v; } public get allWarehousesView(): boolean { return this._allWarehousesView;} private _allWarehousesView: boolean;
    public set canViewAllWarehouses(v: boolean) { this._canViewAllWarehouses = v; } public get canViewAllWarehouses(): boolean { return this._canViewAllWarehouses;} private _canViewAllWarehouses: boolean;
        

    async loadById(invoiceId:string, warehousePartId:string) {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/DeliveryCartableDetail', {
            InvoiceId: invoiceId,
            InvoiceWarehousePartId: warehousePartId,
        });
        this.id = result.InvoiceId;
        this.invoiceNumber = result.InvoiceNumber;
        this.warehousePartId = result.InvoiceWarehousePartId;
        this.creationTime = moment.utc(result.CreatedDate);
        this.deliveryTime = result.DeliveryTime==null ? null : moment.utc(result.DeliveryTime);
        this.collectTime = result.CollectTime==null ? null : moment.utc(result.CollectTime);
        this.sentTime = result.SentTime==null ? null : moment.utc(result.SentTime);
        this.customerName = result.CustomerName;
        this.sellerName = result.SellerName;
        this.collectorId = result.CollectorId;
        this.collectorName = result.CollectorName;
        this.receiverName = result.ReceiverName;
        this.districtName = result.DistrictName;
        this.saleFromWarehouseId = result.SaleFromWarehouseId;
        this.saleFromWarehouseName = result.SaleFromWarehouseName;
        this.deliveryWarehouseId = result.DeliveryWarehouseId;
        this.deliveryWarehouseName = result.DeliveryWarehouseName;
        this.isDeliveryFormPrinted = result.IsDeliveryFormPrinted;
        this.shippingWarehouseState = result.ShippingWarehouseState;
        this.warehouseState = result.DeliveryWarehouseState;
        this.paymentState = result.PaymentState;
        this.canCollect = this.saleFromWarehouseId == this.deliveryWarehouseId && (this.warehouseState == 1 || this.warehouseState == 2);
        this.canDelivery = result.CanDelivery;
        this.canPrint = true;
        this.itemsCount = result.LineItems.length;
        this.lineItems.update(...result.LineItems.map((q, i) => {
            let r = new DeliveryCartableLineItem(this);
            r.rowNumber = i + 1;
            r.id = q.MeasuredProductId;
            r.productCarModel = q.ProductCarModel;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productIndex = q.ProductIndex;
            r.amount = q.Amount;
            r.stock = q.Stock;
            r.warehouseLocation = q.WarehouseLocation;
            return r;
        }));
        this.isMainDistrict = result.IsFromMainDistrict;
        this.isFirstWarehouseExists = stringIsNullOrEmpty(result.MainWarehouseName)===false;
        this.firstWarehouseName = result.MainWarehouseName;
        this.firstWarehouseItems.update(...result.MainWarehouseItems.map((q, i) => {
            let r = new DeliveryCartableLineItem(this);
            r.rowNumber = i + 1;
            r.id = q.MeasuredProductId;
            r.productCarModel = q.ProductCarModel;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productIndex = q.ProductIndex;
            r.amount = q.Amount;
            r.stock = q.Stock;
            r.warehouseLocation = q.WarehouseLocation;
            return r;
        }));  
        
        this.isSecondWarehouseExists = stringIsNullOrEmpty(result.SecondaryWarehouseName)===false;
        this.secondWarehouseName = result.SecondaryWarehouseName;
        this.secondWarehouseItems.update(...result.SecondaryWarehouseItems.map((q, i) => {
            let r = new DeliveryCartableLineItem(this);
            r.rowNumber = i + 1;
            r.id = q.MeasuredProductId;
            r.productCarModel = q.ProductCarModel;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productIndex = q.ProductIndex;
            r.amount = q.Amount;
            r.stock = q.Stock;
            r.warehouseLocation = q.WarehouseLocation;
            return r;
        }));  
        this.canViewAllWarehouses = this.isMainDistrict && this.isFirstWarehouseExists && this.isSecondWarehouseExists;
        this.allWarehousesView = false;
    }

    delivery() {

    }

    async print(){
        new PrintDeliveryFormAction().Print(this, this.id, this.warehousePartId);
    }

    async showCollectorForm() {
        let collectorForm = new DeliveryCartableCollectorViewModel(this, this.id, this.warehousePartId, this.collectorId, this.deliveryWarehouseId);
        let result = await this.requestShowingPopup(collectorForm);
        this._typedParent.refreshClosePopups();
        // this._typedParent.showDetail(this.id, this.warehousePartId);
    }

    async showDeliveryForm() {
        let deliveryForm = new DeliveryFormViewModel(this);
        await deliveryForm.loadById(this.id, this.warehousePartId);
        let result = await this.requestShowingPopup(deliveryForm);
        this._typedParent.refreshClosePopups();
    }

    closePopup() {

    }
}

export class DeliveryCartableLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set stock(v: number) { this._stock = v; } public get stock(): number { return this._stock; } private _stock: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation;} private _warehouseLocation: string;

}

export class PrintDeliveryFormAction{
   
    public set showProductIndexOnPrint(v: boolean) { this._showProductIndexOnPrint = v; } public get showProductIndexOnPrint(): boolean { return this._showProductIndexOnPrint;} private _showProductIndexOnPrint: boolean;

    public async Print(parent:ViewModel, invoiceId, warehousePartId):Promise<void>{
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/DeliveryCartableDetail',{
            ShallPrint: true,
            InvoiceId: invoiceId,
            InvoiceWarehousePartId: warehousePartId
        });
        return this.PrintFromDto(parent,result);
    }

    public async PrintFromDto(parent:ViewModel, result:any){
        try {
            let result = await ServerConnection.callServer('/Complex/SettingServices/GetShowProductIndexOnPrintSetting',{});
                this.showProductIndexOnPrint = result.ShowProductIndexOnPrint;
        } catch (ex) {
            console.log(ex);
        }
        
        let data = <any>{
            CopyCount:1,
            ShowProductIndexOnPrint : this.showProductIndexOnPrint,
            FactorTime: result.CreatedDate,
            FactorCode: result.InvoiceNumber,
            CustomerName: result.CustomerName, 
            SellerName: result.SellerName,
            FactorNo: result.InvoiceNumber,
            FactorCreator: result.Creator,
            CustomerInterfaceName: result.ReceiverName,
        };
        if(result.IsFromMainDistrict){
            if(result.MainWarehouseName==null){
                data.DeliveryWarehouseName= result.SecondaryWarehouseName;
                data.DeliveryQRCode = result.InvoiceId + "," + result.SecondaryWarehousePartId;
                data.DeliveryWarehouse = result.SecondaryWarehouseItems.map((q,i)=>{
                    return {
                        RowIndex: i+1,
                        Code: q.ProductCode,
                        Description: q.ProductName,
                        ProductIndex: q.ProductIndex,
                        Number: q.Amount,
                        WarehousePlacement: q.WarehouseLocation,
                        InStockNumber : q.Stock,
                        AvailableBalance: q.AccessibleStock,
                    };
                });
            }else{
                data.DeliveryWarehouseName= result.MainWarehouseName;
                data.DeliveryQRCode = result.InvoiceId + "," + result.MainWarehousePartId;
                let currentFloor = localStorage.getItem('currentFloorId');
                data.DeliveryWarehouse = result.MainWarehouseItems.filter(q => {
                    return stringIsNullOrEmpty(currentFloor) || q.WarehouseFloorIds.indexOf(null) > -1 || q.WarehouseFloorIds.indexOf(currentFloor) > -1; 
                }).map((q,i)=>{
                    return {
                        RowIndex: i+1,
                        Code: q.ProductCode,
                        Description: q.ProductName,
                        ProductIndex: q.ProductIndex,
                        Number: q.Amount,
                        WarehousePlacement: q.WarehouseLocation,
                        InStockNumber : q.Stock,
                        AvailableBalance: q.AccessibleStock,
                    };
                });
                if(result.SecondaryWarehouseName!=null){
                    data.HasSecondaryWarehouse = true;
                    data.SendingWarehouseName= result.SecondaryWarehouseName;
                    data.SecondaryDeliveryQRCode = result.InvoiceId + "," + result.SaleFromWarehouseId;
                    data.SendingWarehouse = result.SecondaryWarehouseItems.map((q,i)=>{
                        return {
                            RowIndex: i+1,
                            Code: q.ProductCode,
                            Description: q.ProductName,
                            ProductIndex: q.ProductIndex,
                            Number: q.Amount,
                            WarehousePlacement: q.WarehouseLocation,
                            InStockNumber : q.Stock,
                            AvailableBalance: q.AccessibleStock,
                        };
                    })
                }
            }
        }else{
            data.DeliveryWarehouseName= result.DeliveryWarehouseName;
            data.DeliveryWarehouse = result.LineItems.map((q,i)=>{
                return {
                    RowIndex: i+1,
                    Code: q.ProductCode,
                    Description: q.ProductName,
                    ProductIndex: q.ProductIndex,
                    Number: q.Amount,
                    WarehousePlacement: q.WarehouseLocation,
                    AvailableBalance: q.Stock,
                };
            });
        }
        if (data.DeliveryWarehouse.length == 0) {
            return;
        }
        var message = new SendToLocalNotificationMessage("requestPrint",{
            Form:"OrderDelivery",
            Data:data
        });
        return parent.handleMessage(message);
    }
}
